// src/components/TrialModal.js
import React, { useState } from 'react'; // 添加 useState
import styles from '../styles/TrialModal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faEyeSlash, faUserShield, faCoins } from '@fortawesome/free-solid-svg-icons';
import { fetchTestUrl } from '../api/orderApi';
import Loading from './Loading'; // 假设已有 Loading 组件

const TrialModal = ({ isOpen, onClose, userKey = 9913, type = 'grok' }) => {
  const [isLoading, setIsLoading] = useState(false); // 新增 Loading 状态

  if (!isOpen) return null;

  const handleConfirm = async () => {
    setIsLoading(true); // 开始请求时显示 Loading
    try {
      const response = await fetchTestUrl({
        user_key: userKey,
        type: type
      });
      console.log('Raw response:', response);
      const { code, message, data } = response; // 直接从 response 解构
      console.log('Parsed data:', { code, message, data });
      if (code === 200 && data?.url) {
        console.log('Opening URL:', data.url);
        window.open(data.url, '_blank');
        onClose();
      } else {
        console.error('Invalid response:', message);
        alert('获取试用链接失败，请稍后重试');
      }
    } catch (error) {
      console.error('Fetch error:', error);
      alert('请求失败，请检查网络或稍后重试');
    } finally {
      setIsLoading(false); // 请求结束（成功或失败）时隐藏 Loading
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>限时免费体验</h2>
          <p className={styles.modalSubtitle}>尊享AI科技虚拟账户高级功能</p>
          <button className={styles.modalClose} onClick={onClose} disabled={isLoading}>
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          <FontAwesomeIcon icon={faGift} className={styles.modalIcon} />
          <p className={styles.modalText}>
            为保证顾客的购买体验和售后服务，我们提供<span className={styles.modalHighlight}>先试用再购买</span>的政策。立即获取完全免费的7天体验资格！
          </p>
          <div className={styles.trialBenefits}>
            <div className={styles.benefitItem}>
              <div className={styles.benefitIcon}>
                <FontAwesomeIcon icon={faEyeSlash} />
              </div>
              <p className={styles.benefitText}>对话尽自己可见</p>
            </div>
            <div className={styles.benefitItem}>
              <div className={styles.benefitIcon}>
                <FontAwesomeIcon icon={faUserShield} />
              </div>
              <p className={styles.benefitText}>无需担心封号</p>
            </div>
            <div className={styles.benefitItem}>
              <div className={styles.benefitIcon}>
                <FontAwesomeIcon icon={faCoins} />
              </div>
              <p className={styles.benefitText}>价格低至每天1块钱</p>
            </div>
          </div>
          <div className={styles.modalButtons}>
            <button
              className={`${styles.btn} ${styles.btnOutline}`}
              onClick={onClose}
              disabled={isLoading} // 加载时禁用“稍后再说”按钮
            >
              稍后再说
            </button>
            <button
              className={`${styles.btn} ${styles.btnPrimary}`}
              onClick={handleConfirm}
              disabled={isLoading} // 加载时禁用“立即免费体验”按钮
            >
              {isLoading ? '加载中...' : '立即免费体验'} {/* 按钮文本动态切换 */}
            </button>
          </div>
          {isLoading && <Loading />} {/* 显示 Loading 组件 */}
        </div>
      </div>
    </div>
  );
};

export default TrialModal;